module.exports = __webpack_public_path__ + "static/media/sequoia.b3d74513.jpg";